import { RHFTextarea } from '@/components/hook-form/rhf-textarea';
import { RHFImageUpload } from './rhf-image-upload';
import { RHFPromptTextarea } from './rhf-prompt-textarea';
import { RHFMultiSelect, RHFSelect, RHFSelectWithRandom } from './rhf-select';
import { RHFSlider } from './rhf-slider';
import { RHFTextField } from './rhf-text-field';
// ----------------------------------------------------------------------

export const Field = {
  // Code: RHFCode,
  Select: RHFSelect,
  SelectWithRandom: RHFSelectWithRandom,
  // Switch: RHFSwitch,
  Slider: RHFSlider,
  // Rating: RHFRating,
  Text: RHFTextField,
  Textarea: RHFTextarea,
  // Checkbox: RHFCheckbox,
  // RadioGroup: RHFRadioGroup,
  // DatePicker: RHFDatePicker,
  MultiSelect: RHFMultiSelect,
  // MultiSwitch: RHFMultiSwitch,
  // Autocomplete: RHFAutocomplete,
  // MultiCheckbox: RHFMultiCheckbox,
  // CountrySelect: RHFCountrySelect,
  // MobileDateTimePicker: RHFMobileDateTimePicker,
  PromptTextarea: RHFPromptTextarea,
  ImageUpload: RHFImageUpload,
};
